/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import '../styles/vacaciones.css';

// Services
import EmpleadoService from '../services/empleadoService';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT, ROLES_PERMITIDOS } from '../redux/constants/index';

// Components.
import Heading from '../components/heading/Heading';
import msgNotificacion from "../scripts/notification";
import Formatter from '../scripts/formatters';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import Item from '../components/custom/Item';
import { 
  Grid, 
  Typography, 
  TextField, 
  Tooltip, 
  Button,
  Autocomplete,
  useMediaQuery,
  Card,
  CardContent,
  CircularProgress
} from "@mui/material";
import CustomExportPdf from '../components/custom/CustomExportPdf';
import VacacionesDataGrid from '../components/styledDataGrid/VacacionesDataGrid';

// Iconos
import RestartAltIcon from '@mui/icons-material/RestartAlt';

export default function Vacaciones() {
  const dispatch = useDispatch()
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const isMobile = useMediaQuery('(max-width: 740px)')

  // States
  const [loading, setLoading] = useState(false)
  const [dataVacaciones, setDataVacaciones] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [dataEmpleado, setDataEmpleado] = useState()
  const [dataEmpleadosCbo, setDataEmpleadosCbo] = useState([])
  const [empleadoSelected, setEmpleadoSelected] = useState(null)
  const [totales, setTotales] = useState({
    acumulado: 0,
    descansado: 0,
    pagado: 0
  })

  const [valueFechas, setValueFechas] = useState({
    fechaIni: '',
    fechaFin: '',
  })

  // Columns
  const columns = [
    { 
      field: 'Consecutivo',
      headerName: 'No. Acción',
      width: 90,
      align: 'center',
      headerAlign: 'center'  
    },
    { 
      field: 'Fecha',
      headerName: 'Fecha solicitud',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.dateFormatter(value),
    },
    { 
      field: 'FechaInicio',
      headerName: 'Fecha inicio',
      width: 110,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.dateFormatter(value),
    },
    { 
      field: 'FechaFinal',
      headerName: 'Fecha final',
      width: 110,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.dateFormatter(value),
    },
    { 
      field: 'Tipo',
      headerName: 'Tipo de vacación',
      width: 220,            
    },
    { 
      field: 'Cantidad', 
      headerName: 'Cantidad',
      width: 80,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.currencyFormatter(value),
    },
    { 
      field: 'Saldo', 
      headerName: 'Saldo',
      width: 80,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.currencyFormatter(value),
    },
    { 
      field: 'Observaciones',
      headerName: 'Observaciones',
      minWidth: 300,
      flex: 1,
    },  
  ]

  // Arrow functions.
  // Get Vacaciones.
  const getVacaciones = async (data) => {
    try {      
      setLoading(true)

      EmpleadoService.getVacaciones(data)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }          
  
          setTimeout(() => {          
            if (response.Codigo === 1) {
              const dataResponse = response?.Data
              
              setDataEmpleado(dataResponse)
              setDataVacaciones(dataResponse?.Vacaciones)
              sumTotales(dataResponse?.Vacaciones)
              
              if (!valueFechas.fechaIni || !valueFechas.fechaFin) {
                setFilteredData(dataResponse?.Vacaciones)
              } else {
                filtrarVacaciones(valueFechas.fechaIni, valueFechas.fechaFin)
              }
            } else {
              setDataVacaciones([])
              setFilteredData([])
              msgNotificacion(response.Mensaje, 'info')
            }
            
            setLoading(false)
          }, 500);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }
  
  const getDatosEmpleadosCbo = async () => {
    try {      
      EmpleadoService.getDatosCboSolicitud()
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }
  
          if (response.Codigo === 1) {
            const data = response?.Data?.Empleados
            const dataEmpleados = data?.filter(item => item.label.trim() !== 'TODOS')

            setDataEmpleadosCbo(dataEmpleados)
          } else {
            setDataEmpleadosCbo([])
            msgNotificacion(response.Mensaje, 'warning')
          }
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
    }
  }

  const sumTotales = (data) => {
    setTotales({
      ...totales, 
      acumulado: data?.filter(row => row['TipoAccion'] === '21')
        .reduce((sum, row) => sum + row['Cantidad'], 0),
      descansado: data?.filter(row => row['TipoAccion'] === '07')
        .reduce((sum, row) => sum + row['Cantidad'], 0),
      pagado: data?.filter(row => row['TipoAccion'] === '08')
        .reduce((sum, row) => sum + row['Cantidad'], 0),
    })
  }

  const filtrarVacaciones = (fecha1, fecha2) => {
    try {      
      const fechaIni = new Date(fecha1)
      const fechaFin = new Date(fecha2)
      
      const filteredData = dataVacaciones.filter((item) => {
        const itemDate = formatearFecha(item.Fecha)
        const fecha = new Date(itemDate)      
        
        return fecha >= fechaIni && fecha <= fechaFin
      })
  
      setFilteredData(filteredData)      
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeFechas = (event) => {
    try {
      setValueFechas({
        ...valueFechas,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const formatearFecha = (date) => {
    if (!date) {
      return
    }
  
    let dateAsString = date.toString().substring(0, 10)
    let dateParts = dateAsString.split("-")
    let day = dateParts[2]
    let month = dateParts[1]
    let year = dateParts[0]
  
    return `${year}-${month}-${day}`;
  }

  const refreshVacaciones = () => {
    try {
      const dataRequest = {
        codEmpleado: !empleadoSelected ? userLogin.CodigoEmpleado : empleadoSelected.id
      }

      getVacaciones(dataRequest)
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeEmpleado = (event, values) => {
    try {
      setEmpleadoSelected(values)
            
      if (!values) {
        setLoading(true)
        
        setTimeout(() => {
          setFilteredData([])
          setLoading(false)
        }, 500);

        return
      }

      setLoading(true)
      
      const codEmpleado = values.id
      const data = {
        codEmpleado: codEmpleado
      }

      setTimeout(() => {
        getVacaciones(data)
        setLoading(false)
      }, 500);

    } catch (error) {
      console.error(error)
    }    
  }

  let initPage = false
  useEffect(() => {
    document.title = `Registro de Vacaciones - ${NAME_PROJECT}`

    try {
      dispatch(showProgress(true))

      setTimeout(() => {
        if (!initPage) {
          initPage = true

          const data = {
            codEmpleado: userLogin.CodigoEmpleado
          }
          
          getVacaciones(data)

          if (ROLES_PERMITIDOS.includes(userLogin.CodigoRol))
            getDatosEmpleadosCbo()
        }

        dispatch(showProgress(false))
      }, 1000)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return <div className='App-content'>
    <Heading className='mt-0 w-100 heading heading-title'>
      <div className='heading-text w-100 heading-text-vacaciones'>
        <i className='bx bx-calendar-check me-2'></i>
        <span>Historial de Vacaciones</span>
      </div>

      <Autocomplete
        id="cboEmpleados"
        getOptionLabel={option => (option.id + ' - ' + option.label)}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        options={dataEmpleadosCbo}
        fullWidth
        className='me-2 text-transform-none'
        value={empleadoSelected || null}
        onChange={handleChangeEmpleado}
        renderInput={(params) => <TextField {...params} label="Listado de Empleados" className='text-transform-none' />}
      /> 

      <div className='d-flex dv-filt-fechas-vac'>
        <Tooltip title='Refrescar datos'>
          <Button
            variant='outlined'
            className='text-transform-none me-2 btn-refresh-vac'
            color='info'
            startIcon={<RestartAltIcon />}
            onClick={() => refreshVacaciones()}
            size='small'
          >
            Refrescar
          </Button>
        </Tooltip>

        <div className='d-flex'>
          <TextField
              id='txtFechaInicio'
              name='fechaIni'
              type='date'
              label='Fecha inicial'
              size='small'
              value={valueFechas.fechaIni}
              onChange={handleChangeFechas}
              className='ms-auto mx-1 filt-fechas-vac'
              InputLabelProps={{
                shrink: true,
                className: 'LabelMui'
              }}
            />

            <TextField
              id='txtFechaFinal'
              name='fechaFin'
              type='date'
              label='Fecha final'
              size='small'
              value={valueFechas.fechaFin}
              onChange={handleChangeFechas}
              className='mx-1 filt-fechas-vac'
              InputLabelProps={{
                shrink: true,
                className: 'LabelMui'
              }}
            />
        </div>

      </div>
    </Heading>

    <Grid container spacing={1}>
      <Grid item xs={12} md={12} className='pb-2 heading-buttons justify-content-center heading-subtitle'>
        <Grid container>
          <Typography component='div' className='col-md-4 col-info'>
            Nombre: <span className='text-warning'>{dataEmpleado?.Nombres}</span>
          </Typography>
          <Typography component='div' className='col-md-4 col-info'>
            Cédula: <span className='text-warning'>{dataEmpleado?.Cedula}</span>
          </Typography>
          <Typography component='div' className='col-md-4 col-info'>
            Cargo: <span className='text-warning'>{dataEmpleado?.Cargo}</span>
          </Typography>
          <Typography component='div' className='col-md-4 col-info'>
            Área: <span className='text-warning'>{dataEmpleado?.Area}</span>
          </Typography>
          <Typography component='div' className='col-md-4 col-info'>
            Ingreso: <span className='text-warning'>{Formatter.dateFormatter(dataEmpleado?.FechaIng)}</span>
          </Typography>
          <Typography component='div' className='col-md-4 col-info'>
            Salario: <span className='text-warning'>{dataEmpleado?.Moneda} {Formatter.currencyFormatter(dataEmpleado?.Salario || 0)}</span>
          </Typography>
        </Grid>
      </Grid>

      <>
        {isMobile ? (
          loading ?
            <Grid container spacing={1} paddingX={1} height='100%' textAlign='center' alignItems='center'>
              <Grid item xs={12}>
                <CircularProgress color='inherit' />
              </Grid>
            </Grid>
          :
          <Grid container spacing={1} paddingX={1} paddingTop={1} marginLeft={0}>
            <Typography
              textAlign='center'              
              bgcolor='#dc3545'
              component='div'
              className='d-flex justify-content-evenly w-100 mt-2 ms-2 totals-vac'
              borderRadius={1}
            >
                             <span>Total Acumulado: {Formatter.currencyFormatter(totales.acumulado)}</span>
               <span>Total Descansados: {Formatter.currencyFormatter(totales.descansado)}</span>
               <span>Total Pagados: {Formatter.currencyFormatter(totales.pagado)}</span>
               <span className='fw-bolder'>Saldo: {Formatter.currencyFormatter(totales.acumulado - totales.descansado - totales.pagado)}</span>
            </Typography>
            {filteredData.map((row) => (
              <Grid item xs={12} key={row.Consecutivo}>
                <Card>
                  <CardContent>
                    <Typography variant="h6"><strong>Acción #{row.Consecutivo}</strong></Typography>
                    <Typography variant="body2">
                      <strong>Fecha Registro:</strong><span className='mx-1 text-blue'>{Formatter.dateFormatter(row.Fecha)}</span>
                    </Typography>
                    <Typography variant="body2">
                      <strong>Fecha Inicio:</strong><span className='mx-1'>{Formatter.dateFormatter(row.FechaInicio)}</span>
                    </Typography>
                    <Typography variant="body2">
                      <strong>Fecha Final:</strong><span className='mx-1'>{Formatter.dateFormatter(row.FechaFinal)}</span>
                    </Typography>
                    <Typography variant="body2">
                      <strong>Cantidad:</strong><span className={`mx-1 fw-bold ${row.TipoAccion === '21' ? 'text-success' : 'text-danger'}`}>{`${row.TipoAccion === '21' ? '+' : '-'}`}{row.Cantidad}</span>
                    </Typography>
                    <Typography variant="body2">
                      <strong>Saldo:</strong><span className='mx-1 fw-bold text-blue'>{row.Saldo}</span>
                    </Typography>
                    <Typography variant="body2">
                      <strong>Tipo de Vacación:</strong><span className='mx-1'>{row.Tipo}</span>
                    </Typography>
                    <Typography variant="body2">
                      <strong>Motivo:</strong><span className='mx-1'>{row.Observaciones}</span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
            <Grid item xs={12} md={12} marginX={1}>
              <Item className='MuiPaper-root-dataGrid-vacaciones'>
                <VacacionesDataGrid
                  rows={filteredData}
                  columns={columns}
                  getRowId={(row) => row?.Consecutivo}
                  pageSize={PAGE_SIZE}
                  pageSizeOptions={[5, 10, 25, 50, 100]}
                  loading={loading}
                  localeText={Formatter.localizedTextsMapColumns}
                  getRowClassName={(params) => `super-app-theme--${params.row?.TipoAccion}`}
                  // Ocultar la casilla de check all.
                  sx={{
                    "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                      display: "none"
                    }
                  }}
                  showCellVerticalBorder
                  showColumnVerticalBorder
                  slots={{
                    noRowsOverlay: CustomNoRowsOlverlay,
                    toolbar: (props) => (
                      <CustomExportPdf {...props} codEmpleado={!empleadoSelected ? userLogin.CodigoEmpleado : empleadoSelected.id} additionalTitle={dataEmpleado?.Nombres} tableRef={filteredData} totales={totales} />
                    )
                  }}
                />
              </Item>

              <Typography
                textAlign='center'
                fontWeight='bold'
                bgcolor='#dc3545'
                component='div'
                className='d-flex justify-content-evenly'
              >
                                 <span>Total Acumulado: {Formatter.currencyFormatter(totales.acumulado)}</span>
                 <span>Total Descansados: {Formatter.currencyFormatter(totales.descansado)}</span>
                 <span>Total Pagados: {Formatter.currencyFormatter(totales.pagado)}</span>
                 <span>Total Saldo: {Formatter.currencyFormatter(totales.acumulado - totales.descansado - totales.pagado)}</span>
              </Typography>
            </Grid>
        )
        }
      </>
    </Grid>
  </div> 
}